var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "gridChatWindowContact", staticClass: "grid-chat-window-contact" },
    [
      _c("ChatWindow", {
        key: _vm._contact._id,
        ref: "chatWindow",
        style: { width: _vm.chatWindowWidth },
        attrs: { contact: _vm._contact },
      }),
      _vm._v(" "),
      _c("UserInfoWidget", {
        attrs: {
          contact: _vm._contact,
          maxUserInfoWidgetWidth: _vm.maxUserInfoWidgetWidth,
          minUserInfoWidgetWidth: _vm.minUserInfoWidgetWidth,
          "disabled-resize": _vm.disabledResize,
        },
        on: { width: _vm.resizingUserInfoWidget },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }